
<div class="home">
  <h1 class="display-1 pageTitle">{{ $t("IMAGE_PREVIEW_HEADER") }}</h1>
  <div class="previewIntro">
    <p class="subheading" v-html="imagePreviewText"></p>
    <ShopNavigationActions :step="2" class="d-none d-md-flex"/>
  </div>
  <v-card v-if="active" class="imageContainer imagePresentation">
    <v-container grid-list-sm fluid>
      <VirtualScroll
          :active="active"
          :initial-items-count="8"
          :preload-padding="getImageHeight()"
          :items="imageSelection.images"
          :visible-window="window"
          class="imageLayout"
          v-masonry
          column-width="137"
          gutter="8"
          transition-duration="0s"
      >
        <template scope="{item, index}">
          <div v-masonry-tile
               :style="{width: getImageWidth(item) + 'px'}"
               :class="{imageSelectionDiv: true, landscape: item.orientation === 'LANDSCAPE', portrait: item.orientation === 'PORTRAIT'}"
          >
            <ImagePreview
                class="imageItem"
                :image="item"
                :small-height="getImageHeight() + 'px'"
                :small-width="getImageWidth(item) + 'px'"
                :ref="`preview-${index}`"
                :hasPreviousPreview="hasPreviousPreview(index)"
                :hasNextPreview="hasNextPreview(index)"
                @openPrevious="openPreview(index-1)"
                @openNext="openPreview(index+1)"
            />
          </div>
        </template>
      </VirtualScroll>
    </v-container>
  </v-card>

  <div class="shopNavigationButtons previewBottomNavigation">
    <v-btn color="primary" @click="select">{{ $t("BUTTON_CONTINUE") }}</v-btn>
  </div>
  <NewsletterDialog/>
</div>
